import { Link } from "react-router-dom";
import { HOME_URL_LOCAL } from "../../utility/BaseUrl";

export default function AboutUs({ about }) {
  if (about)
    return (
      <>
        <main className="page-container text-container text-group-container">
          <div className="container">
            <div className="page-context text-context text-group-context">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={HOME_URL_LOCAL} className="text-muted">
                    <span className="d-flex align-items-center">
                      <i
                        className="fa fa-home text-primary breadcrumb-home-icon d-inline-flex ml-10 position-relative text-xl"
                        aria-hidden="true"
                      />
                      خانه
                    </span>
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  <span>درباره ما</span>
                </li>
              </ol>
              <h1 className="page-title text-title text-group-title">
                درباره ما
              </h1>
              {about.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="text-content text-group-content figure-content break-word"
                    dangerouslySetInnerHTML={{
                      __html: item.about_me,
                    }}
                  />
                );
              })}
            </div>
          </div>
        </main>
      </>
    );
}
